// Off until Google approves the contacts scope for our OAuth client — flip to true to restore.
export const CONTACT_SUGGESTIONS_ENABLED: boolean = false;
